import React, { useState, useEffect } from "react";
import Pagination from "../../extra/Pagination";
import { ReactComponent as TrashIcon } from "../../../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/EditBtn.svg";
import Table from "../../extra/Table";
import Searching from "../../extra/Searching";
import { warning } from "../../../util/Alert";
import { connect, useDispatch, useSelector } from "react-redux";
import Button from "../../extra/Button";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { getRewardApi, deleteReward } from "../../store/reward/reward.action";
import AddrewardAds from "../../extra/AddrewardAds";

const AdReward = (props) => {
  const dispatch = useDispatch();
  const { startDate, endDate } = props;
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [actionPagination, setActionPagination] = useState("delete");
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectCheckData, setSelectCheckData] = useState([]);
  const [search, setSearch] = useState();
  const [data, setData] = useState([]);
  const { reward, totalRewards } = useSelector((state) => state.reward);
  const { dialogueType } = useSelector((state) => state.dialogue);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleSelectCheckData = (e, row) => {
    const checked = e.target.checked;
    if (checked) {
      setSelectCheckData((prevSelectedRows) => [...prevSelectedRows, row]);
    } else {
      setSelectCheckData((prevSelectedRows) =>
        prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id),
      );
    }
  };

  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);
    if (checked) {
      setSelectCheckData([...data]);
    } else {
      setSelectCheckData([]);
    }
  };

  const paginationSubmitButton = () => {
    const selectCheckDataGetId = selectCheckData?.map((item) => item?._id);
    if (actionPagination === "delete") {
      const data = warning();
      data
        .then((res) => {
          if (res) {
            const yes = res.isConfirmed;
            if (yes) {
              props.deleteReward(selectCheckDataGetId);
            }
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  const handleEdit = (row, type) => {
    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
        data: row,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
      dialogueData: row,
    };
    localStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const handleDeleteReward = (row) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          if (res.isConfirmed) {
            const id = row?._id;
            props.deleteReward(id);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const rewardMapData = [
    {
      Header: "checkBox",
      width: "20px",
      Cell: ({ row }) => (
        <input
          type="checkbox"
          checked={selectCheckData.some(
            (selectedRow) => selectedRow?._id === row?._id,
          )}
          onChange={(e) => handleSelectCheckData(e, row)}
        />
      ),
    },
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => (
        <span className="  text-nowrap">
          {(page - 1) * size + parseInt(index) + 1}
        </span>
      ),
    },
    {
      Header: "Ad Name",
      body: "adName",
      Cell: ({ row }) => <span className="cursorPointer">{row?.adName}</span>,
    },
    {
      Header: "COIN EARNED FROM AD",
      body: "coins",
      Cell: ({ row }) => <span className="cursorPointer">{row?.coins}</span>,
    },
    {
      Header: "Status",
      body: "isActive",
      Cell: ({ row }) => (
        <span className="cursorPointer text-nowrap text-capitalize">
          {row?.isActive == 1 ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      Header: "ACTION",
      body: "action",
      Cell: ({ row }) => (
        <div className="action-button">
          <Button
            btnIcon={<EditIcon />}
            onClick={() => handleEdit(row, "editAdReward")}
          />

          <Button
            btnIcon={<TrashIcon />}
            onClick={() => handleDeleteReward(row)}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    dispatch(getRewardApi(page, size, startDate, endDate));
  }, [dispatch, startDate, endDate, page, size]);

  useEffect(() => {
    // console.log("CategoryData", categoryData);
    setData(reward);
  }, [reward]);
  return (
    <div>
      <div className="user-table mb-3">
        <div className="user-table-top">
          <h5
            style={{
              fontWeight: "500",
              fontSize: "20px",
              marginTop: "5px",
              marginBottom: "4px",
            }}
          >
            Ads coins Reward
          </h5>
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "16px",
              borderRadius: "20px",
            }}
          >
            {dialogueType === "editAdReward" && <AddrewardAds />}
            {dialogueType !== "editAdReward" && (
              <Button
                onClick={() => handleEdit(null, "editAdReward")}
                btnName={"New Ad Reward"}
                style={{ width: "150px" }}
              />
            )}
            {/* 
            <Searching
              label={"Search for ID, Keyword, Name "}
              placeholder={"Search..."}
              data={reward}
              type={"client"}
              setData={setData}
              onFilterData={handleFilterData}
              searchValue={search}
              customSelectDataShow={true}
              customSelectData={["Delete"]}
              actionPagination={actionPagination}
              setActionPagination={setActionPagination}
              paginationSubmitButton={paginationSubmitButton}
            /> */}
          </div>
        </div>
        <Table
          data={data}
          mapData={rewardMapData}
          serverPerPage={size}
          serverPage={page}
          handleSelectAll={handleSelectAll}
          selectAllChecked={selectAllChecked}
          type={"server"}
        />
        <div className="mt-3">
          <Pagination
            type={"server"}
            activePage={page}
            rowsPerPage={size}
            userTotal={totalRewards}
            setPage={setPage}
            handleRowsPerPage={handleRowsPerPage}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default connect(null, {
  getRewardApi,
  deleteReward,
})(AdReward);
